<template>
    <div>
        <el-form label-position="left" label-width="100px">
            <el-form-item label="请求地址：">
                <!--<el-color-picker v-model="data.color"></el-color-picker>-->
                <el-input placeholder="请输入请求地址" v-model="data.address"></el-input>
            </el-form-item>
            <el-form-item label="字段名称：">
                <!--<el-color-picker v-model="data.color"></el-color-picker>-->
                <el-input placeholder="请输入字段名称" v-model="data.fieldName"></el-input>
            </el-form-item>




        </el-form>
    </div>
</template>

<script>
    export default {
        name: "config-general",
        props: ['data'],
        data () {
            return{

            }
        },
        methods: {

        },
        watch: {

        }
    }
</script>

